import { DataModel } from "common/models/utility-models/base-model";

export class UsersModel extends DataModel {
    first_name: any = '';
    last_name: any = '';
    email: any = ''

}